import { render, staticRenderFns } from "./dateItem.vue?vue&type=template&id=0a370bbb&scoped=true"
import script from "./dateItem.vue?vue&type=script&lang=js"
export * from "./dateItem.vue?vue&type=script&lang=js"
import style0 from "./dateItem.vue?vue&type=style&index=0&id=0a370bbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a370bbb",
  null
  
)

export default component.exports